<script setup lang="ts">
useHead({
    title: 'SHAPTH',
    meta: [
        {
            name: 'description',
            content:
                'SHAPTH - Schnittstellenharmonisierung und Austauschplattform Trinkwasserhygiene'
        }
    ],
    link: []
});
</script>

<template>
    <router-view v-slot="{ Component }">
        <component :is="Component" />
    </router-view>
    <Toast
        position="bottom-center"
        :pt="{ messageText: { class: 'relative bottom-[0.15rem]' } }"
    />
</template>
